import { render, staticRenderFns } from "./wifi-config.vue?vue&type=template&id=ef444d66&"
import script from "./wifi-config.vue?vue&type=script&lang=ts&"
export * from "./wifi-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports